import { render, staticRenderFns } from "./Detection.vue?vue&type=template&id=0e60bc1e"
import script from "./Detection.vue?vue&type=script&lang=js"
export * from "./Detection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports